import './index.css';
import './template.css';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/css/index.js